<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500 capitalize">Παραγγελίες Πωλήσεων</h4>
        </div>

        <BaseAdvancedList
          searchable
          :loading="loading"
          :with-list-header="listHeader"
          :with-list-item="listItem"
          :entities="productionOrders"
          :meta="meta"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ListHeader from '@/components/ProductionOrders/ListHeader.vue';
import ListItem from '@/components/ProductionOrders/ListItem.vue';

export default {
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState('ui/productionOrders', ['meta']),
    ...mapGetters('ui/productionOrders', ['productionOrders']),
    listHeader() {
      return ListHeader;
    },
    listItem() {
      return ListItem;
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/productionOrders', ['fetchProductionOrderList']),
    ...mapMutations('ui/productionOrders', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { query: params } = this.$route;
      this.loading = true;
      try {
        await this.fetchProductionOrderList({ params });
      } catch (error) {
        //
      }
      this.loading = false;
    },
  },
};
</script>
